import { Button, Dialog, Table, TextField } from 'src/components';
import { type ChangeEvent, useState } from 'react';
import { Grid, Typography } from '@material-ui/core';
import { type RootState } from 'src/store';
import { useDispatch, useSelector } from 'react-redux';
import SearchIcon from '@material-ui/icons/Search';
import _ from 'lodash';
import useStyles from './LayoutUploadSummaryDialog-styles';
import userActions from 'src/store/Users/actions';

function LayoutUploadSummaryDialog() {
	const classes = useStyles();
	// NOTE: Ver todas las notas de ./src/modules/private/Admin.tsx
	const dispatch = useDispatch();
	const { bulkUploadSummary, bulkUploadSummaryOpen: open } = useSelector(
		(state: RootState) => state.users,
	);
	const handleOpen = () =>
		dispatch(
			userActions.setBulkUploadSummary({
				created: [],
				total: 0,
				updated: [],
			}),
		);
	const [search, setSearch] = useState('');

	const columns = [
		{
			key: 'username',
			label: 'Usuario',
			render: (value: any, row: any) => value,
		},
		{
			key: 'password',
			label: 'Password',
			render: (value: any, row: any) => value,
		},
		{
			key: 'email',
			label: 'Email',
			render: (value: any, row: any) => value,
		},
		{
			key: 'firstname',
			label: 'Nombre(s)',
			render: (value: any, row: any) => value,
		},
		{
			key: 'lastname',
			label: 'Apellidos',
			render: (value: any, row: any) => value,
		},
		{
			key: 'institution',
			label: 'Institución',
			render: (value: any, row: any) => value,
		},
		{
			key: 'department',
			label: 'Departamento',
			render: (value: any, row: any) => value,
		},
		{
			key: 'course',
			label: 'Curso',
			render: (value: any, row: any) => value,
		},
		{
			key: 'actions',
			label: 'Detalle',
			render: function Render(value: any, row: any) {
				return (
					<div>
						{value.map((val: string, index: number) => (
							<Typography className={classes.action} key={index}>
								{' '}
								{`${index + 1}. ${val}.`}{' '}
							</Typography>
						))}
					</div>
				);
			},
		},
	];

	return (
		<Dialog
			actions={
				<Grid container justify={'space-between'}>
					<Grid item xs={6}>
						<Typography className={classes.title}>
							{' '}
							Total registros: {bulkUploadSummary.total}{' '}
						</Typography>
					</Grid>

					<Button
						actionType={'save'}
						color={'secondary'}
						onClick={handleOpen}
						variant={'contained'}
					>
						Aceptar
					</Button>
				</Grid>
			}
			content={
				<Grid container>
					<Grid className={classes.header} container item xs={12}>
						<Grid item md={3} xs={6}>
							<TextField
								InputProps={{
									endAdornment: <SearchIcon />,
								}}
								label={'Buscar'}
								onChange={(
									event: ChangeEvent<HTMLInputElement>,
								) => {
									setSearch(event.target.value);
								}}
								value={search}
							/>
						</Grid>
					</Grid>

					<Grid item xs={12}>
						<Typography className={classes.title}>
							{' '}
							Usuarios creados: {
								bulkUploadSummary.created.length
							}{' '}
						</Typography>

						<Table
							columns={columns}
							data={_.filter(
								bulkUploadSummary.created,
								(item: any) => {
									return (
										item.username?.includes(search) ||
										item.email?.includes(search) ||
										item.firstname?.includes(search) ||
										item.lastname?.includes(search) ||
										item.institution?.includes(search) ||
										item.department?.includes(search) ||
										item.course?.includes(search)
									);
								},
							)}
							hidePagination
						/>
					</Grid>

					<Grid item xs={12}>
						<Typography className={classes.title}>
							{' '}
							Usuarios actualizados:{' '}
							{bulkUploadSummary.updated.length}{' '}
						</Typography>

						<Table
							columns={columns}
							data={_.filter(
								bulkUploadSummary.updated,
								(item: any) => {
									return (
										item.username?.includes(search) ||
										item.email?.includes(search) ||
										item.firstname?.includes(search) ||
										item.lastname?.includes(search) ||
										item.institution?.includes(search) ||
										item.department?.includes(search) ||
										item.course?.includes(search)
									);
								},
							)}
							hidePagination
						/>
					</Grid>
				</Grid>
			}
			fullScreen
			handleOpen={handleOpen}
			maxWidth={'lg'}
			open={open}
			title={'Usuarios procesados'}
		/>
	);
}

export default LayoutUploadSummaryDialog;
